import styled from 'styled-components';

import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { mediaUp, rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing20,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  borderRadius8,
  boxShadow815Grey,
} from 'approot/shared/styles/borders.style';
import {
  Heading20,
  PStyled,
  font18,
  font30,
} from 'approot/shared/styles/typography.style';
import {
  azure1,
  grey1,
  grey10,
  grey4,
  purple1,
  purple9,
} from 'approot/shared/styles/colours.style';
import {
  SecondaryBaseStyled,
  SecondaryButtonAndIcon,
} from 'approot/shared/styles/buttons/secondary-button.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const InteractiveResponseCheck = styled.div`
  ${flexCentreAlignCss}
  margin-bottom: ${rem(spacing24)};
`;

export const CheckAnswer = styled.div`
  left: 50%;
  max-width: ${rem(400)};
  padding: ${rem(spacing16)};
  position: fixed;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  z-index: 100;

  ${SecondaryButtonAndIcon} {
    justify-content: center;
    width: 100%;
  }
`;

export const CheckAnswerContainer = styled.div`
  ${boxShadow815Grey}

  background-color: ${grey1};
  border-radius: ${rem(12)};
  border: 1px solid ${grey4};
  padding: ${rem(spacing12)};
`;

export const CheckAnswerText = styled(PStyled)`
  background-color: ${purple1};
  border-radius: ${rem(borderRadius8)};
  margin-bottom: ${rem(spacing12)};
  padding: ${rem(spacing12)};
  text-align: center;
`;

export const CheckAnswerTitle = styled(Heading20).attrs({
  as: 'h2',
  colour: grey10,
  textAlignCenter: true,
})``;

export const CheckAnswerMoreInfo = styled.div`
  ${font18}

  ${mediaUp.md`
    ${font30}  
  `}
  
  width: 100%;
  max-width: ${rem(1016)};
  color: ${purple9};
  background-color: ${purple1};
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(spacing24)};
  text-align: center;
`;

export const CheckAnswerWrapper = styled(Box).attrs({
  $flexDirection: 'column',
  $alignItems: 'center',
})`
  width: 100%;
`;

export const CheckAnswerIconButton = styled.button`
  ${SecondaryBaseStyled}
  ${boxShadow815Grey}

  background-color: ${azure1};
  border-radius: 50%;
  border: 1px solid ${grey4};
  bottom: ${rem(spacing16)};
  min-width: auto;
  position: fixed;
  padding: ${rem(spacing12)};
  right: ${rem(spacing20)};
  width: ${rem(56)};
  height: ${rem(56)};
  z-index: 99;

  &:hover,
  &:focus {
    background-color: ${azure1};
  }

  ${mediaUp.md`
    width: ${rem(80)};
    height: ${rem(80)};
  `}

  svg {
    width: 100%;
    height: auto;
  }
`;
